// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prd.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    name: 'dev',
    // Configuration Cognito Open id accessible via l'url : https://cognito-idp.<region>.amazonaws.com/<poolId>/.well-known/openid-configuration
    // Par exemple : https://cognito-idp.eu-west-3.amazonaws.com/eu-west-3_OizJDS0Km/.well-known/openid-configuration
    clientId: '5tu3vo2vlsr67ipg2jkmavvpf3',
    loginUrl: 'https://lguserpoolportailrhdev.auth.eu-west-3.amazoncognito.com/oauth2/authorize',
    issuer: 'https://cognito-idp.eu-west-3.amazonaws.com/eu-west-3_OizJDS0Km',
    logoutUrl: 'https://lguserpoolportailrhdev.auth.eu-west-3.amazoncognito.com/logout',
    tokenEndpoint: 'https://lguserpoolportailrhdev.auth.eu-west-3.amazoncognito.com/oauth2/token',
    userinfoEndpoint: 'https://lguserpoolportailrhdev.auth.eu-west-3.amazoncognito.com/oauth2/userInfo',
    jwks: {
        keys: [
            {
                alg: 'RS256',
                e: 'AQAB',
                kid: 'ijjOuuCbnKWrfy/948eMGObHdefIKZpMmQ18QWRgVT0=',
                kty: 'RSA',
                n: 'xDskgNZ5gTib81ASLs-epuSDHKIc3RJWvjgxxAcDNixCVUZHFiq8Ta0p4OmgVDR-3el4MOJK3kd22IXVmBDJKQPgRlOFlP7M4911D5uhDvNTtDwPt-xa7TKkED6mDn2KDBW8yBX1tzF79K2dIrvL6OYlccVveBoHk8uubkRzjABDfeqFaDlV0ea3aG1ktPThY1mDY_Zr3FzJgxvjJ0pdWYRj3JQ9sL6L5QebSsAW1vWQJBgyOhAq1XR7NZ6vOJQ47HRQkLMY8PPD-y4N_eiO-gGGoJy6y9yFUlWIMs6L8lNAWKHXDY7VXUbiwKcnGJs6MMeggJ58QO2mocNXxNCbSQ',
                use: 'sig',
            },
            {
                alg: 'RS256',
                e: 'AQAB',
                kid: 'zpMRuBLcYFa9+0n2NK+Dd3LAzHVULamGYExkaUkUXow=',
                kty: 'RSA',
                n: 'yFV0YhmidxK70skaYu59AwSRnUg-8-w7T9GPkPrTHbkvnHDLj4L3Hb_2RGkV_66-qG3g5YyEOhwKquKjWpMQy8q9D3s9el2OSV6TrL7pvMXPm9NviGWqaF0KPxWaIz_o3JXEP3e-7fkA89dckvUoyD2L-WrZz2gK1vHZ-L2uQKdbLC7fpACKZIq_OoDjJ4WGLes4Cu-5m0pPBKt_eTqS4Y4qZj8OTtwVzh9c1RoNHGqITZ0gKPkKpT9Ee2Yiswy1xtVlSIe4BuZwFVIXRMmUNmfoZ0bOMkG5YZYdomK92I1CCSHgKCKGX18u8J4r9whr7r02Uvw_i1EiBCzymI4BVQ',
                use: 'sig',
            },
        ],
    },
    baseUrl: 'https://myteam-dev.leon-grosse.fr/portail-rh-api-rest',
    apimUrl: 'https://apis-rec.leon-grosse.fr/dev/ref',
    apimLogin: 'https://apis-rec.leon-grosse.fr/oauth2/token',
    utilisateurApi: '/utilisateur',
    collaborateurApi: '/collaborateur',
    equipeGlobaleApi: '/utilisateur/equipeGlobale',
    relationApi: '/relation?envoiEmail=false',
    organigrammeApi: '/collaborateur/organigramme',
    comiteOrganigrammeApi: '/comite/organigramme',
    comiteApi: '/comite',
    comiteMembreApi: '/comite-membre',
    delegationApi: '/delegation',
    relationActiveValideurApi: '/relation-valideur/relations-collaborateur',
    modificationSuchargeValideurApi: '/relation-valideur',
    relationValideurCollaborateurEntiteApi: '/relation-valideur/relations-entite',
    // Spinner global properties
    ngxSpinnerOptions: {
        type: 'ball-clip-rotate-multiple',
        bdColor: 'rgba(255,255,255,0.5)',
        color: '#999',
        fullscreen: false,
    },
    helpUrl: 'https://sites.google.com/leongrosse.fr/myteam/accueil',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
